module.exports = __webpack_public_path__ + "img/ESP.2cd3832a.svg";